<div
  class="one3d-color-palette"
  [ngClass]="{ 'one3d-color-palette-active' : menuVisible}"
>
  <div
    class="one3d-color-wrapper"
    [attr.data-color]="trimSelected?.color_name"
  >
    <span
      *ngFor="let trim of trims"
      (click)="selectTrim(trim)"
      class="one3d-colors one3d-colors-single-tone"
      [attr.data-color]="trim?.color_name"
    >
      <img
        class="one3d-center-xy"
        *ngIf="trim?.variant_color_id == this.trimSelected?.variant_color_id"
        src="assets/img/icons/one3d-color-check.svg"
        alt="color-checked icon"
      />
      <span
        class="one3d-colors-dual-tone"
        [ngStyle]="{ background: returnColor(trim.color_code) }"
      ></span>
      <span
        class="one3d-colors-dual-tone"
        [ngStyle]="{ background: returnDualToneColor(trim.color_code) }"
      ></span>
    </span>
  </div>
</div>
